import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { DissolveCompany, DissolveCompanyForm } from "./dissolveCompanyDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<DissolveCompany>,
): DissolveCompanyForm {
  return new DissolveCompanyForm(context);
}

export function applyForm(): DissolveCompany {
  return {
    type: DecisionType.dissolveCompany,
  };
}

export function validate(): boolean {
  return true;
}

export function isValid(): boolean {
  return true;
}

export const dissolveCompanyHandler: DecisionTypeHandler<
  DecisionType.dissolveCompany,
  DissolveCompany,
  DissolveCompanyForm
> = {
  type: DecisionType.dissolveCompany,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
